import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconPencil } from '../../Icons';
import { useAppStore } from '../../store/AppContext';
import DataService from '../../services/MisDatosService';
import useAPILoading from '../../hooks/useLoading';
import { PrefijoPais } from '../../types/PersonalData';
import RedesSociales from './RedesSociales';
import { useAuthStore } from '../../store/AuthContext';
import useAPIError from '../../hooks/useAPIError';
import ModalConfirmacion from '../../components/ModalConfirmacion';
import { getCookies } from '../../api/api';
import ServicioSms from './servicioSms';
import { BackMappings } from '../../utils/BackMappings';
import { SessionChecker } from '../../utils/SessionChecker';
import { HostProvider } from '../../utils/HostProvider';
import { StorageHelper } from '../../utils/StorageHelper';
import { FrontMappings } from '../../utils/FrontMappings';

interface Props {
  setUserForm: (userForm: boolean) => void;
  setPassForm: (passForm: boolean) => void;
  emailAcceso: string;
  dobleVerificacion: boolean;
  showAccessData: boolean;
  load: boolean;
  promiseApi: boolean;
  cargarPersonalData: () => void;
  cargarData: () => void;
  prefijosPaises: PrefijoPais[];
  setShowPersonalData: (show: boolean) => void;
  handlerErrorUpdate?: (isError: boolean) => void;
  origenData: string;
}

const AccesData: FC<Props> = (props) => {
  const {
    setPassForm,
    setUserForm,
    emailAcceso,
    load,
    cargarPersonalData,
    cargarData,
    prefijosPaises,
    dobleVerificacion,
    showAccessData,
    promiseApi,
    setShowPersonalData,
    handlerErrorUpdate,
    origenData,
  } = props;
  const { t } = useTranslation();
  const dataApp = useAppStore();
  const { setApiLoading } = useAPILoading();
  const dataUser = useAuthStore();
  const { addError } = useAPIError();
  const [showModal, setShowModal] = useState(false as boolean);
  const [startSmsService, setStartSmsService] = useState(false);
  const [showActivaV2PModal, setShowActivaV2PModal] = useState(false);
  const [updateSmsService, setUpdateSmsService] = useState(false);
  const [checkActivaV2PModal, setCheckActivaV2PModal] = useState(false);
  const [showErrorV2PModal, setShowErrorV2PModal] = useState(false);
  const [firstCharge, setFirstCharge] = useState(true);
  const opcion = 'accessData' as string;
  const titleDeactivation = t(
    'datos.accessdata.sms-service-deactivation-title',
  );
  const textDeactivation = t(
    'datos.accessdata.sms-service-deactivation-message',
  );
  const titleActivationV2P = t(
    'datos.accessdata.sms-service-v2pactivate-title',
  );
  const textActivationV2P = t(
    'datos.accessdata.sms-service-v2pactivate-message',
  );
  const acceptButtonTextKey = t('global.confirm');
  const acceptActivateV2PButtonTextKey = t(
    'datos.accessdata.sms-service-v2pactivate-ok',
  );
  const cancelActivateV2PButtonTextKey = t(
    'datos.accessdata.sms-service-v2pactivate-cancel',
  );

  const isApp = dataUser.user.isApp === 'true';
  const isCaprabo = HostProvider.isCaprabo();

  const hacerLogoutMultidispositivos = () => {
    DataService.logoutMultidispositivo().then((response) => {
      if (response.data.error) {
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      } else {
        setApiLoading(true);
        dataApp.closeSession();
      }
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const emptymethod = () => {
    setShowActivaV2PModal(false);
    // window.removeEventListener(
    //   'keydown',
    //   function (e) {
    //     console.log(e);
    //   },
    //   false,
    // );
  };

  const clickSwitch = async (e: any) => {
    if (!e.target.checked) {
      let allCookiesDeleted = false as boolean;
      while (!allCookiesDeleted) {
        const cookies = getCookies().get(`${dataUser.user.idShopper}_FLG_V2P`);
        if (cookies) {
          if (isCaprabo) {
            getCookies().remove(`${dataUser.user.idShopper}_FLG_V2P`, {
              domain: '.caprabo.com',
            });
          } else {
            getCookies().remove(`${dataUser.user.idShopper}_FLG_V2P`, {
              domain: '.eroski.es',
            });
          }
        } else {
          allCookiesDeleted = true;
        }
      }
      if (!showActivaV2PModal) {
        setShowModal(true);
      }
    } else {
      const response = await SessionChecker.checkSession(
        BackMappings.MISDATOS,
        dataApp.lang,
        dataUser.user.isApp === 'true',
        dataUser.user.isRecuerdame,
      );
      if (response) {
        setStartSmsService(true);
      }
    }
  };

  useEffect(() => {
    if (showActivaV2PModal && !showModal && promiseApi) {
      const element = document.querySelector(
        '#modal-confirmacion1.is-active',
      ) as HTMLElement;
      if (element) {
        element.classList.remove('is-active');
      }
      setShowModal(false);
      setShowActivaV2PModal(false);
    }
  }, [showModal, showActivaV2PModal, showErrorV2PModal, promiseApi]);

  const activateV2PServiceModal = () => {
    if (!updateSmsService) {
      setUpdateSmsService(true);
      setStartSmsService(true);
      setShowActivaV2PModal(false);
    }
  };

  const checkDoubleV2P = (isSpinner) => {
    if (!isSpinner && checkActivaV2PModal && firstCharge) {
      if (!dobleVerificacion && origenData === 'mis-datos') {
        setShowActivaV2PModal(!showErrorV2PModal);
        setCheckActivaV2PModal(false);
      }
    }
    setFirstCharge(false);
  };
  const getTesauro = () => {
    if (
      sessionStorage.getItem('tesauro') === null ||
      sessionStorage.getItem('tesauro') === undefined
    ) {
      DataService.getTesauro()
        .then((response) => {
          if (!response.data.error) {
            sessionStorage.setItem(
              'tesauro',
              JSON.stringify(response.data.pojo),
            );
          } else {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
          }
        })
        .catch((e) => {
          console.log(e);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        });
    }
  };

  useEffect(() => {
    if (!promiseApi) {
      checkDoubleV2P(promiseApi);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [promiseApi]);

  useEffect(() => {
    if (dataUser.user.token !== '') {
      const scrollYAbrirDirFacturacion = StorageHelper.getScrollAbrirFacturacion() as string;
      const isAbrirFacturacion =
        Boolean(scrollYAbrirDirFacturacion) &&
        scrollYAbrirDirFacturacion.trim().toLowerCase() === 'true';
      const url = window.location.pathname;
      const isCambioEmail = url.includes(FrontMappings.CAMBIO_MAIL);
      const isCambioPass = url.includes(FrontMappings.CAMBIO_PASS);
      if (isCambioPass) {
        setPassForm(true);
        getTesauro();
      }
      const isBajaDigital = url.includes(FrontMappings.BAJA_DIGITAL);
      const isShowV2p =
        !isAbrirFacturacion &&
        !isCambioEmail &&
        !isCambioPass &&
        !isBajaDigital;
      if (isShowV2p) {
        const v2P = StorageHelper.getOpenV2PFromOro();
        if (v2P !== null && v2P === 'true') {
          StorageHelper.removeOpenV2PFromOro();
          setShowErrorV2PModal(true);
          setShowActivaV2PModal(false);
        }
        setCheckActivaV2PModal(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUser.user.token]);

  const deactivateSMSService = () => {
    const data = {
      fromApp: isApp ? 'app_club' : 'web',
      dobleVerificacion: false,
    };
    DataService.updateDatosAcceso(data)
      .then((response) => {
        if (response.data.error === false) {
          cargarData();
        } else {
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        }
      })
      .catch((er: any) => {
        console.log(er);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
      });
  };

  return (
    <>
      {(() => {
        if (load && showAccessData) {
          return (
            <>
              <div className="divider" />
              <div className="bloque-datos">
                {/* <Heading text="datos.accesdata" setShow={setVisible} /> */}
                <h2 id="acceso" className="bloque-datos__title u-text-brand">
                  <span className="divider__square brand-color" />
                  <span className="u-margin-right">
                    {t('datos.accessdata.heading')}
                  </span>
                </h2>
                <div className="bloque-datos__datos">
                  <ul className="bloque-datos__list u-margin-bottom">
                    <li>
                      <p className="bloque_usuario">
                        {t('datos.accessdata.user')}: &nbsp;
                        <strong>{emailAcceso}</strong>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                        <a
                          className="bloque-datos__action edit-email"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setUserForm(true);
                            document.body.classList.add('fix');
                          }}
                        >
                          <span className="hidden">
                            Enlace a la edicion del bloque
                          </span>
                          <span className="icon icon__stroke icon-round">
                            <IconPencil />
                          </span>
                        </a>
                      </p>
                    </li>
                    <li>
                      <p className="bloque_usuario">
                        {t('datos.accessdata.password')}:{' '}
                        <strong>**********</strong>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                        <a
                          className="bloque-datos__action edit-acceso"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setPassForm(true);
                            getTesauro();
                            document.body.classList.add('fix');
                          }}
                        >
                          <span className="hidden">
                            Enlace a la edicion del bloque
                          </span>
                          <span className="icon icon__stroke icon-round">
                            <IconPencil />
                          </span>
                        </a>
                      </p>
                    </li>
                  </ul>
                  <RedesSociales />
                  <div className="form-group form-group-switch u-margin-bottom">
                    <span className="control-label">
                      {t(
                        'datos.accessdata.activate-retrieve-pass-and-verication-two-steps',
                      )}
                    </span>
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label className="switch">
                      <input
                        id="checkbox"
                        type="checkbox"
                        checked={dobleVerificacion}
                        readOnly
                        onClick={(e) => clickSwitch(e)}
                      />
                      <span className="slider-switch round" />
                    </label>
                  </div>
                  {!isApp ? (
                    <p className="bloque-datos__link">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                      <a
                        className="link"
                        onClick={() => {
                          hacerLogoutMultidispositivos();
                        }}
                      >
                        {t('datos.accessdata.singout-all-devices')}
                      </a>
                    </p>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </>
          );
        }
        return false;
      })()}
      <ModalConfirmacion
        isBig={false}
        isSmall
        textCentered
        showModal={showModal}
        setShowModal={setShowModal}
        title={t(titleDeactivation)}
        textHTMLContent={t(textDeactivation)}
        doAceptar={deactivateSMSService}
        doClose={emptymethod}
        showCancel
        acceptButtonTextKey={acceptButtonTextKey}
      />
      {showActivaV2PModal && (
        <ModalConfirmacion
          isBig={false}
          isSmall
          textCentered
          showModal={showActivaV2PModal}
          setShowModal={setShowActivaV2PModal}
          title={t(titleActivationV2P)}
          textHTMLContent={t(textActivationV2P)}
          doAceptar={activateV2PServiceModal}
          doClose={emptymethod}
          showCancel
          acceptButtonTextKey={t(acceptActivateV2PButtonTextKey)}
          cancelButtonTextKey={t(cancelActivateV2PButtonTextKey)}
        />
      )}
      <ServicioSms
        startService={startSmsService}
        setStartSmsService={setStartSmsService}
        opcion={opcion}
        setShowPersonalData={setShowPersonalData}
        prefijosPaises={prefijosPaises}
        cargarPersonalData={cargarPersonalData}
        cargarAccessData={cargarData}
        setShowOroError={handlerErrorUpdate}
        origenData={origenData}
      />
    </>
  );
};

export default AccesData;
